export function formatMinutesAsDuration(totalMinutes) {
    const parsedMinutes = parseFloat(totalMinutes);
    if (parsedMinutes == null || Number.isNaN(parsedMinutes)) {
        return "-";
    }

    const sign = parsedMinutes < 0 ? "-" : "";
    const absoluteMinutes = Math.abs(parsedMinutes);

    const roundedMinutes = Math.round(absoluteMinutes);
    const hours = Math.floor(roundedMinutes / 60);
    const minutes = roundedMinutes % 60;

    return `${sign}${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}m`;
}